import React, { Component } from 'react';
import { Breadcrumb } from '@blueprintjs/core'
import ReactGA from 'react-ga'
import { base, app } from '../../base'


class Blog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            comments: {},
            user: app.auth().currentUser
    }
}




    addComment(comment) {

    }



    componentWillMount() {

    }
  
    componentWillUnmount() {
      }
    render() {
        return (
            <div>
                <ul className="pt-breadcrumbs">
                    <li><Breadcrumb href="/home" text="Home" /></li>
                    <li><Breadcrumb href="/blog" text="Blog" /></li>
                </ul>
                <hr />
                <div>
                    <h3>Blog</h3>
                    <div>
                        <div>
                            Coming Soon!
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

export default Blog;


// WEBPACK FOOTER //
// ./src/components/blog/Blog.jsx